<template>
  <el-dialog
    :title="$t('eventList.AppPro')"
    :visible.sync="dialogVisible"
    width="40%"
    class="approvalProcessDialog"
    @close="dialogCloseHandle"
  >
    <el-scrollbar class="approvalProcessScrollbar">
      <div class="processTitle" v-if="verifyFlag && verifyProcessData.length > 0">{{$t('eventList.EAAF')}}</div>
      <commonProcess :process-data="activityProcessData" />
      <div class="processTitle" v-if="verifyFlag && verifyProcessData.length > 0">{{$t('eventList.AvAf')}}</div>
      <commonProcess :process-data="verifyProcessData" v-if="verifyFlag && verifyProcessData.length > 0" />
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import commonProcess from 'components/commonProcess';
import { activityQueryDetails } from '@/views/activitieList/service';
export default {
  data () {
    return {
      dialogVisible: false,
      activityProcessData: [],
      verifyProcessData: [],
      verifyFlag: false
    };
  },
  props: {
    isReport: {
      type: Boolean,
      default: false
    },
    approvalProcessVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    approvalProcessVisible (val) {
      if (val) {
        // 是否是报备申请
        if (this.isReport) {
          // 报备申请审批流
          this.getReportProcessHistory();
        } else {
          this.verifyFlag = this.rowData.stat === 50 || this.rowData.stat === 55 || this.rowData.stat === 60;
          // 活动申请审批流
          this.getActivityApprovalProcess();

          if (this.verifyFlag) {
            // 活动核销审批流
            this.getVerifyProcessLog();
          }
        }
      }
      this.dialogVisible = val;
    }
  },
  components: {
    commonProcess
  },
  methods: {
    getReportProcessHistory () {
      activityQueryDetails.getReportProcessHistory(this.rowData.id).then(res => {
        if (res.status === '200') {
          this.activityProcessData = res.data.mactFlowLogReportList.map(item => {
            return {
              title: item.node,
              details: item.reason,
              type: item.approveType,
              name: item.assigneeName,
              time: item.createTime,
              active: res.data.processState === 'completed'
            };
          });
          if (res.data.processState === 'completed') {
            this.activityProcessData = [
              ...this.activityProcessData,
              {
                name: this.$t('general.End'),
                active: true
              }
            ];
          }
          this.$nextTick(() => {
            let ele = document.querySelector('.approvalProcessScrollbar>.el-scrollbar__wrap');
            ele.scrollTo(0, ele.scrollHeight);
          });
        }
      });
    },
    getActivityApprovalProcess () {
      activityQueryDetails.getProcessHistory(this.rowData.id).then(res => {
        if (res.status === '200') {
          this.activityProcessData = res.data.mactFlowLogList.map(item => {
            return {
              title: item.node,
              details: item.reason,
              type: item.approveType,
              name: item.assigneeName,
              time: item.createTime,
              active: res.data.processState === 'completed'
            };
          });
          if (res.data.processState === 'completed') {
            this.activityProcessData = [
              ...this.activityProcessData,
              {
                name: this.$t('general.End'),
                active: true
              }
            ];
          }
          this.$nextTick(() => {
            let ele = document.querySelector('.approvalProcessScrollbar>.el-scrollbar__wrap');
            ele.scrollTo(0, ele.scrollHeight);
          });
        }
      });
    },
    getVerifyProcessLog () {
      activityQueryDetails.getVerifyProcessLog(this.rowData.id).then(res => {
        if (res.status === '200') {
          this.verifyProcessData = res.data.map(item => {
            if (item.processState === 'completed') {
              return {
                name: this.$t('general.End'),
                active: true
              };
            }
            return {
              title: item.node,
              details: item.reason,
              type: item.approveType,
              name: item.assigneeName,
              time: item.time,
              active: item.processState === 'completed'
            };
          });
          this.$nextTick(() => {
            let ele = document.querySelector('.approvalProcessScrollbar>.el-scrollbar__wrap');
            ele.scrollTo(0, ele.scrollHeight);
          });
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style lang="scss" scoped>
.approvalProcessDialog{
  ::v-deep.el-dialog{
    .approvalProcessScrollbar{
      >.el-scrollbar__wrap {
        overflow-x: hidden;
        max-height: 500px;
      }
    }
    .processTitle{
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 16px;
      &~.processTitle{
        margin-top: 10px;
      }
    }
  }
}
</style>
